export default __webpack_public_path__ + "static/475-4c005fed6234c2fa5774c5ded1e590ad.gif";